
import TimeUnit from "./TimeUnit.js";
import ZonedClock from "./ZonedClock.js";
import DateUtils from "@/utils/DateUtils.js";
import RcMonth from "./RcMonth.js";
import RcDay from "./RcDay.js";
import RcYear from "./RcYear.js";
import RcQuarterHour from "./RcQuarterHour.js";

/** An hour of the day, mirroring com.readychek.time.RcHour. */
export default class RcHour extends TimeUnit {

  constructor(date, timeZone) {
    super(date, timeZone);
  }

  /** The 24 hour hour, read in this unit's zone. */
  value() {
    return this.hourValue();
  }

  name() {
    return this.value();
  }

  day() {
    return new RcDay(this.date(), this.timeZone());
  }

  month() {
    return new RcMonth(this.date(), this.timeZone());
  }

  year() {
    return new RcYear(this.date(), this.timeZone());
  }

  quarter() {
    return new RcQuarterHour(this.date(), this.timeZone());
  }

  /** The top of this hour. */
  start() {
    return new RcHour(
      ZonedClock.withFields(this.date(), this.timeZone(), { minute: 0, second: 0, milli: 0 }),
      this.timeZone(),
    );
  }

  /** The last moment of this hour. */
  end() {
    return new RcHour(
      ZonedClock.withFields(this.date(), this.timeZone(), { minute: 59, second: 59, milli: 999 }),
      this.timeZone(),
    );
  }

  next() {
    return this.plus(1);
  }

  previous() {
    return this.minus(1);
  }

  minus(hours) {
    return new RcHour(new Date(this.time() - DateUtils.hours(hours)), this.timeZone());
  }

  plus(hours) {
    return new RcHour(new Date(this.time() + DateUtils.hours(hours)), this.timeZone());
  }
}
